import { formatFilterCountSuffix } from "@/marketplace/count-active-filters";
import { resolveActionBarFacetActiveCount } from "@/marketplace/action-bar-facet-active-counts";

function setFacetDropdownTriggerState(
    trigger: HTMLButtonElement,
    defaultLabel: string,
    activeCount: number,
): void {
    const label = defaultLabel + formatFilterCountSuffix(activeCount);
    const labelEl = trigger.querySelector<HTMLElement>(
        "[data-facet-trigger-label]",
    );
    if (labelEl) {
        labelEl.textContent = label;
    } else {
        const caret = trigger.querySelector(".marketplace-facet-dropdown__caret");
        trigger.textContent = "";
        trigger.append(`${label} `);
        if (caret) trigger.appendChild(caret);
    }

    trigger.classList.toggle(
        "marketplace-action-bar__btn--primary",
        activeCount > 0,
    );
}

/** Sync action-bar facet dropdown triggers: label + count suffix and active styling. */
export function updateActionBarFacetDropdownLabels(): void {
    if (typeof document === "undefined") return;

    document
        .querySelectorAll<HTMLElement>("[data-facet-dropdown]")
        .forEach((dropdown) => {
            const mountId = dropdown.dataset.facetMount;
            const defaultLabel = dropdown.dataset.facetLabel ?? "";
            const trigger = dropdown.querySelector<HTMLButtonElement>(
                "[data-facet-dropdown-trigger]",
            );
            if (!trigger || !mountId) return;

            setFacetDropdownTriggerState(
                trigger,
                defaultLabel,
                resolveActionBarFacetActiveCount(mountId),
            );
        });
}
